import React, { useEffect, useState } from 'react'
import { ItemsRequestModel } from '.'
import GenerateIcon from '../../components/GenerateIcon'
import WarehousesApp, { IWarehouseModel } from '../warehouses/WarehousesApp'
import SectionsApp, { ISectionModel } from '../sections/SectionsApp'
import LocationsApp, { ILocationModel } from '../locations/LocationsApp'
import { Skeleton } from '@mui/material'
import { useDispatch } from 'react-redux'
import { error } from 'console'
import { handleRequestError } from '../../services/api'
import UsersApp from '../user/UsersApp'
import { IUserModel } from '../../services/user'

interface IRequestDestinationProps {
    request: ItemsRequestModel,
}

export default function RequestDestination(props: IRequestDestinationProps) {

    const dispacth = useDispatch()

    const { request } = props
    const { designation_type, destination_location, destination_warehouse, destination_section, destination_user } = request

    const [warehouse, setWarehouse] = useState<IWarehouseModel | null>(null)
    const [section, setSection] = useState<ISectionModel | null>(null)
    const [location, setLocation] = useState<ILocationModel | null>(null)
    const [user, setUser] = useState<IUserModel | null>(null)

    const warehousesApp = new WarehousesApp()
    const sectionsApp = new SectionsApp()
    const locationsApp = new LocationsApp()
    const usersApp = new UsersApp()

    /**
     * Load warehouse
     */
    const loadWarehouse = () => {
        if (warehouse){
            return;
        }

        if (!destination_warehouse){
            return;
        }

        warehousesApp.singleInstanceDetails(destination_warehouse)
            .then(response => {
                setWarehouse(response.data)
            })
            .catch(error => {
                handleRequestError(error, dispacth)
            })
    }

    const loadSection = () => {
        if (section){
            return;
        }

        if (!destination_section){
            return;
        }

        sectionsApp.singleInstanceDetails(destination_section)
            .then(response => {
                setSection(response.data)
            })
            .catch(error => {
                handleRequestError(error, dispacth)
            })
    }

    const loadLocation = () => {
        if (location){
            return;
        }

        if (!destination_location){
            return;
        }

        locationsApp.singleInstanceDetails(destination_location)
            .then(response => {
                setLocation(response.data)
            })
            .catch(error => {
                handleRequestError(error, dispacth)
            })
    }

    const loadUser = () => {
        if (user){
            return;
        }

        if (!destination_user){
            return;
        }

        usersApp.singleInstanceDetails(destination_user)
            .then(response => {
                setUser(response.data)
            })
            .catch(error => {
                handleRequestError(error, dispacth)
            })
    }

    useEffect(() => {

        if (designation_type == "warehouse"){
            loadWarehouse()
            loadSection()
        }

        if (designation_type == "location"){
            loadLocation()
        }

        if (designation_type == "user"){
            loadUser()
        }

    }, [])

    const returnWarehouse = () => {
        return(
            <div className="request-designtaions-container item-current-location">
                <div className="content-of-item-current-location">

                    <div className="item-single-current-location">
                        <div className="content-of-item-single-current-location">
                            <h4>{warehouse ? warehouse.title : <Skeleton variant="text" width={30} />}</h4>
                        </div>
                    </div>

                    <GenerateIcon icon="arrow-right" />

                    <div className="item-single-current-location">
                        <div className="content-of-item-single-current-location">
                            <h4>{section ? section.title : <Skeleton variant="text" width={30} />}</h4>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    switch(designation_type){

        case "warehouse":
            return returnWarehouse()

        case "location":
            return(
                <div className="request-designtaions-container">
                    <div className="item-single-current-location">
                        <div className="content-of-item-single-current-location">
                            <h4>{location ? location.title : <Skeleton variant="text" width={30} />}</h4>
                        </div>
                    </div>
                </div>
            )

        case "user":
            return(
                <div className="request-designtaions-container">
                    <div className="item-single-current-location">
                        <div className="content-of-item-single-current-location">
                            <h4>{user ? `With ${user.full_name}` : <Skeleton variant="text" width={30} />}</h4>
                        </div>
                    </div>
                </div>
            )

        default:
            return <p>Unknown destination type</p>
    }
    
}